import { Link } from 'react-router-dom';
import { BookType } from '../api/types';
import { Badge } from './Badge';

type BookCardProps = {
  book: BookType;
};

export const BookCard = ({ book }: BookCardProps) => {
  return (
    <Link to={`/books/${book.id}`}>
      <div
        key={book.id}
        className="relative bg-white flex flex-col cursor-pointer shadow-sm hover:shadow-xl rounded-xl transition duration-500 h-full">
        {book.category && (
          <div className="absolute top-4 right-4">
            <Badge text={book.category} />
          </div>
        )}
        <img
          src={book.cover}
          alt={book.title}
          className="w-full h-[30rem] object-cover rounded-t-xl"
        />
        <div className="p-2 flex flex-col justify-between ">
          <div className='flex gap-1 flex-col'>
            <div className="flex justify-between">
              <h2 className="font-semibold">{book.title}</h2>
              {book.price && <p className="text-green-600 font-semibold text-sm">€ {book.price}</p>}
            </div>
            <p className="text-cyan-500 font-semibold text-sm">{book.author}</p>
          </div>
          <div className="text-sm mt-2">
            <p>
              {book.owner.first_name} {book.owner.last_name}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};
